"use client";

import { useEffect } from "react";

type DeferredGoogleAdsProps = {
  tagId: string;
};

type GoogleAdsWindow = Window & {
  dataLayer?: unknown[][];
  gtag?: (...args: unknown[]) => void;
};

export function DeferredGoogleAds({ tagId }: DeferredGoogleAdsProps) {
  useEffect(() => {
    const scriptId = `feedvote-google-ads-${tagId}`;

    const loadGoogleAds = () => {
      if (document.getElementById(scriptId)) return;

      const analyticsWindow = window as GoogleAdsWindow;
      analyticsWindow.dataLayer ??= [];
      analyticsWindow.gtag = (...args: unknown[]) => {
        analyticsWindow.dataLayer?.push(args);
      };

      const script = document.createElement("script");
      script.id = scriptId;
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(tagId)}`;
      document.head.appendChild(script);

      analyticsWindow.gtag("js", new Date());
      analyticsWindow.gtag("config", tagId);
    };

    window.addEventListener("pointerdown", loadGoogleAds, {
      once: true,
      passive: true,
    });
    window.addEventListener("scroll", loadGoogleAds, {
      once: true,
      passive: true,
    });
    window.addEventListener("keydown", loadGoogleAds, { once: true });

    return () => {
      window.removeEventListener("pointerdown", loadGoogleAds);
      window.removeEventListener("scroll", loadGoogleAds);
      window.removeEventListener("keydown", loadGoogleAds);
    };
  }, [tagId]);

  return null;
}
